<template>
  <div class>
    <drawer
      :title="addEditTitle"
      :dialogShow="addEditShow"
      @handleChange="handleChangeDrawer"
    >
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            class="mobile-ruleForm card-ruleForm"
            label-width="114px"
            label-position="left"
          >
            <div class="iscompanyQuit" v-if="!form.id">
              <img
                src="../../../assets/images/new/blueInfo.png"
                alt=""
              />离职材料可上传手写离职申请书、聊天记录截图等材料
            </div>
            <div v-if="!form.id">
              <el-form-item
                class="el-form-item-update"
                ref="staffName"
                label="店员姓名"
                prop="staffName"
                v-if="isSuperManage"
              >
                <el-select
                  v-model="form.staffId"
                  placeholder="请选择"
                  class="w200"
                  :disabled="isDisable"
                  @change="onClickStaff"
                >
                  <el-option
                    v-for="item in allStaffList"
                    :key="item.id"
                    :label="item.staffName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="el-form-item-update" label="店员姓名" v-else>
                <el-input
                  v-model="userInfo.staffName"
                  disabled
                  readonly
                  class="w200"
                ></el-input>
              </el-form-item>

              <el-form-item class="el-form-item-update" label="入职时间">
                <el-date-picker
                  v-model="joinTime"
                  type="date"
                  readonly
                  disabled
                  class="w200"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                class="el-form-item-update"
                ref="expectQuitTime"
                label="离职日期"
                required=""
              >
                <el-date-picker
                  v-model="form.expectQuitTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  class="cur w200"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                class="el-form-item-update"
                ref="quitType"
                label="离职类型"
                required=""
              >
                <el-select
                  v-model="form.quitType"
                  clearable
                  placeholder="请选择"
                  class="w200"
                >
                  <el-option
                    v-for="item in optionList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                class="el-form-item-update"
                ref="categoryId"
                label="离职原因"
                required=""
              >
                <el-select
                  v-model="form.categoryId"
                  clearable
                  placeholder="请选择"
                  class="w200"
                >
                  <el-option
                    v-for="item in optionName"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="refund_box">
                <span class="money">*</span>&nbsp;<span class="color666"
                  >离职备注</span
                >
                <el-input
                  type="textarea"
                  maxlength="150"
                  show-word-limit
                  :rows="3"
                  placeholder="请输入离职原因"
                  v-model="form.quitReason"
                  style="padding-top: 10px;"
                ></el-input>
              </div>
              <div class="refund_box">
                <span class="color666">离职材料</span>
                <div class="right-img mt10">
                  <imgUpload
                    @file="getFile"
                    :fileList="form.materialUrl"
                    @delete="handleDelete"
                    :imgHide="imgHide"
                    module="companyQuit"
                  ></imgUpload>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="totals-box pl24 white">
                <div class="flex-row mb30">
                  <div class="itemName">姓名</div>
                  <div class="itemNum">{{ form.staffName }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">审核状态</div>
                  <div class="itemNum">
                    <span class="jishi">{{ form.auditStatusCn }}</span>
                  </div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">申请日期</div>
                  <div class="itemNum">{{ formatDay(form.oxCtime) }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">离职日期</div>
                  <div class="itemNum">
                    {{ formatDay(form.expectQuitTime) }}
                  </div>
                </div>
                <div
                  class="flex-row mb30"
                  v-if="
                    form.auditStatus == 'wait' || form.auditStatus == 'pass'
                  "
                >
                  <div class="itemName">实际离职日期</div>
                  <div class="itemNum">
                    <div v-if="form.auditStatus == 'pass'">
                      {{ formatDay(form.realQuitTime) }}
                    </div>
                    <el-date-picker
                      v-else
                      v-model="form.realQuitTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择日期"
                      style="width: 200px;"
                      class="cur"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">离职类型</div>
                  <div class="itemNum">{{ form.quitTypeCn }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">离职原因</div>
                  <div class="itemNum">{{ form.quitCateName }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">离职备注</div>
                  <div class="itemNum">{{ form.quitReason }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">离职材料</div>
                  <div class="itemNum">
                    <el-image
                      style="width: 100px; height: 100px"
                      class="mt10"
                      :src="form.materialUrl"
                      :preview-src-list="[form.materialUrl]"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
              <div class="mb20" v-if="form.auditStatus != 'cancel'">
                <p class="order-title-boxs">
                  <span class="blueBlock"></span><i>审核流程</i>
                </p>
                <div
                  class="flex-row mlr24"
                  v-for="(item, index) in form.flowAuditRecordList"
                  :key="index"
                >
                  <div class="process-left">
                    <div class="process-boxs">
                      <div class="process-img">
                        <img
                          :src="item.headImgUrl"
                          alt=""
                          v-if="item.headImgUrl"
                        />
                        <img
                          src="../../../assets/images/staffJounary_headerImg.png"
                          alt=""
                          v-else
                        />
                        <div class="audit-img">
                          <img
                            src="../../../assets/images/audit_success.png"
                            alt=""
                            v-if="item.auditStatus == 'pass'"
                          />
                          <img
                            src="../../../assets/images/audit_wait.png"
                            alt=""
                            v-else-if="item.auditStatus == 'wait'"
                          />
                          <img
                            src="../../../assets/images/audit_refuse.png"
                            alt=""
                            v-else-if="item.auditStatus == 'refuse'"
                          />
                        </div>
                      </div>
                      <div
                        class="process-vertical"
                        v-if="form.flowAuditRecordList.length - index != 1"
                      ></div>
                    </div>
                  </div>
                  <div class="ml16 w100b process-right">
                    <div class="align-items color999 f12">
                      <div>{{ item.flowNodeName }}</div>
                      <div>{{ formatDate(item.auditTime) }}</div>
                    </div>
                    <div
                      class="mt5 f16"
                      :class="[
                        form.flowAuditRecordList.length - index != 1
                          ? 'mb40'
                          : 'mb10',
                      ]"
                    >
                      {{ item.auditOpName
                      }}<span v-if="item.auditStatus"
                        >（{{ item.auditStatusCn }}）</span
                      >
                    </div>
                    <div
                      class="process-refuse"
                      v-if="item.auditStatus == 'refuse'"
                    >
                      {{ item.auditRemark }}
                    </div>
                  </div>
                </div>
                <!-- <div class="totals-box pl24" v-for="(item,index) in form.flowAuditRecordList" :key="index">
                   <div class="flex-row mb30">
                    <div class="itemName">{{ item.flowNodeName }}</div>
                    <div class="itemNum jishi">{{ item.auditStatusCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核人</div>
                    <div class="itemNum">{{ item.auditOpName }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核时间</div>
                    <div class="itemNum">{{item.auditTime ? formatDate(item.auditTime) : ''}}</div>
                  </div>
								</div> -->
              </div>
            </div>
          </el-form>
        </div>
        <div class="drawer-footer">
          <div
            class="btns pr24 pb10"
            style="display: flex;align-items: center;"
          >
            <el-button type="primary" v-if="!form.id" @click="onSubmit"
              >提交申请</el-button
            >
            <el-button type="primary" v-if="form.editFlag" @click="againSubmit"
              >重新申请</el-button
            >
            <div
              v-perm="{
                key: 'attendancePunch',
                value: 'attendancePunch:quitAudit',
              }"
            >
              <el-button
                class="btn-dandu ml10"
                v-if="form.refuseFlag"
                @click="cancel('refuse')"
                >拒绝</el-button
              >
              <el-button
                type="primary"
                v-if="form.agreeFlag"
                @click="cancel('pass')"
                >同意</el-button
              >
              <el-button
                type="warning"
                v-if="form.cancelFlag"
                @click="cancel('cancel')"
                >撤销</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js';
import imgUpload from '../../../components/common/modules/singleUpload.vue';
import drawer from '../../../components/common/drawer';
export default {
  mixins: [minxin],
  components: { drawer, imgUpload },
  data() {
    return {
      addEditTitle: '',
      addEditShow: false,
      optionName: [], // 请假人
      allStaffList: [], // 请假类型
      multiple: false,
      imgHide: true,
      form: {
        id: '',
        materialUrl: '',
      },
      userInfo: {},
      joinTime: '',
      isSuperManage: false,
      source: '',
      auditList: [],
      optionList: [],
      isDisable: false,
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    getFile(res) {
      this.form.materialUrl = res;
      if (this.form.materialUrl.length >= 1) {
        this.imgHide = false;
      }
    },
    onClickStaff() {
      this.allStaffList.map((item) => {
        if (this.form.staffId == item.id) {
          this.joinTime = this.formatDay(item.joinTime);
          this.form.staffName = item.staffName;
        }
      });
    },
    handleDelete(res) {
      this.form.materialUrl = '';
      this.ossMerchatDelImg(res);
      if (this.form.materialUrl.length < 1) {
        this.imgHide = true;
      }
    },
    editInit() {
      this.$on('set', function(org) {
        Object.assign(this.$data, this.$options.data());
        this.getAllStaff();
        this.getCompanyQuit();
        this.addEditShow = true;
        this.auditList = [];
        console.log('222', this.$store.getters.ShopInfo, this.source);
        this.isSuperManage = this.$store.getters.ShopInfo.superManage;
        if (sessionStorage.getItem('attendanceParmas')) {
          let obj = JSON.parse(sessionStorage.getItem('attendanceParmas'));
          this.source = obj.source;
          console.log('333', this.source);
          this.form.staffId = obj.id;
          this.userInfo.staffName = obj.staffName;
          this.isDisable = true;
          this.$api
            .get(this.$url.companyQuit.getByStaffId, { staffId: obj.id })
            .then((res) => {
              if (res) {
                this.joinTime = this.formatDay(res.joinTime);
                this.addEditTitle = '离职申请';
              }
            });
          sessionStorage.removeItem('attendanceParmas');
          return;
        }
        this.userInfo = org;
        this.source = org.source || 'superManage';
        
        console.log('444', this.source, org); 
        if (this.source == 'staff' || this.source == 'staffManage') {
          if (this.source == 'staff') {
            this.$api
              .get(this.$url.companyQuit.get, { id: org.id })
              .then((res) => {
                if (res) {
                  console.log(res, 'ss');
                  this.form = res;
                  this.addEditTitle = '离职详情';
                }
              });
          } else {
            this.$api
              .get(this.$url.companyQuit.getByStaffId, { staffId: org.id })
              .then((res) => {
                if (res) {
                  this.form = res;
                  this.addEditTitle = '离职详情';
                } else {
                  this.addEditTitle = '离职申请';
                  if (this.isSuperManage)
                  this.isDisable = this.isSuperManage;
                  this.form.staffId = org.id;
                  this.form.staffName = org.staffName;
                  this.joinTime = this.formatDay(this.userInfo.joinTime);
                  console.log('555', this.form, org);
                }
              });
          }
        } else {
          this.addEditTitle = '离职申请';
          console.log('6666', org);
          if (this.source == 'companyQuit') {
            
          } else {
            this.form.staffId = org.id;
            this.form.staffName = org.staffName;
            this.joinTime = this.formatDay(org.joinTime || org.shopJoinTime);
            console.log(this.form);
          }
        }
      });
    },
    againSubmit(row) {
      this.form.materialUrl = '';
      let id = this.form.staffId;
      let name = this.form.staffName;
      this.joinTime = this.formatDay(this.form.joinTime);
      this.addEditTitle = '离职申请';
      this.form = {
        materialUrl: '',
        staffId: id,
        staffName: name,
      };
    },
    getAllStaff() {
      this.$api.post(this.$url.companyStaff.listAll).then((res) => {
        if (res) {
          this.allStaffList = res;
        }
      });
      this.$api
        .get(this.$url.companyQuit.listCategory)
        .then((res) => {
          if (res) {
            this.optionName = res;
          }
        })
        .catch((error) => {});
    },
    getCompanyQuit() {
      this.$api.get(this.$url.companyQuit.getAllQuitType).then((res) => {
        if (res) {
          this.optionList = res;
        }
      });
    },
    handleChangeDrawer() {
      this.$refs['form'].clearValidate();
      this.addEditShow = false;
    },
    onSubmit(values) {
      console.log(this.form);
      if (this.isSuperManage && !this.form.staffId) {
        return this.$message.error('请选择店员姓名');
      }
      if (!this.form.expectQuitTime) {
        return this.$message.error('请选择离职日期');
      } else if (!this.form.quitType) {
        return this.$message.error('请选择离职类型');
      } else if (!this.form.categoryId) {
        return this.$message.error('请选择离职原因');
      } else if (!this.form.quitReason) {
        return this.$message.error('请输入离职原因备注');
      } else if (this.form.materialUrl.length == 0) {
        return this.$message.error('请上传离职材料');
      }
      // this.form.staffId = this.userInfo.id;
      // this.form.staffName = this.userInfo.staffName;
      this.$api.post(this.$url.companyQuit.apply, this.form).then((res) => {
        if (res) {
          this.addEditShow = false;
          this.$message.success('操作成功');
          this.$emit('change', true);
        }
      });
    },
    cancel(value) {
      if (value == 'pass' && !this.form.realQuitTime) {
        return this.$message.error('请选择实际离职时间');
      }
      let msg;
      if (value == 'refuse') {
        msg = `确定要拒绝吗?`;
      } else if (value == 'pass') {
        msg = `确认已上传本人离职申请表?`;
      } else {
        msg = `确定要撤销吗?`;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [h('span', { style: 'color: red' }, msg)]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      }).then((action) => {
        if (value == 'pass' || value == 'refuse') {
          this.$api
            .post(this.$url.companyQuit.audit, {
              staffId: this.form.staffId,
              auditStatus: value,
              realQuitTime: this.form.realQuitTime,
            })
            .then((res) => {
              if (res) {
                this.addEditShow = false;
                this.$message.success('操作成功');
                this.$emit('change', true);
              }
            });
        } else {
          this.$api
            .get(this.$url.companyQuit.cancel, {
              staffId: this.form.staffId,
            })
            .then((res) => {
              if (res) {
                this.addEditShow = false;
                this.$message.success('撤销成功');
                this.$emit('change', true);
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
@import '../../../assets/css/edit.less';
.refund_box {
  background: #fff;
  padding: 10px 20px;

  .infos {
    color: #ff892a;
    padding-bottom: 10px;
  }
}
.leaveBox {
  background: #fff;
  padding: 10px 20px;
}
/deep/ .el-dialog {
  margin-top: 20vh !important;
}
.pay-mains {
  padding: 0;
  .card-ruleForm {
    padding-bottom: 0;
    padding-top: 10px;
    /deep/ .el-form-item {
      padding: 10px 20px;
      margin-bottom: 0;
    }
    .el-form-item-update {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      margin: 0;
      background: #fff;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
      }
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
.money {
  color: #f56c6c !important;
}
.process-boxs {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-img {
  width: 40px;
  height: 40px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.audit-img {
  width: 14px;
  height: 14px;
  position: absolute;
  right: 0;
  bottom: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.process-vertical {
  width: 2px;
  height: 32px;
  margin: 4px 0;
  background: #e6e6e6;
}
.process-right {
  .process-refuse {
    padding: 12px;
    margin-top: 8px;
    color: #666;
    background: #f2f1f6;
    border-radius: 4px;
  }
}

</style>
